import { Button } from '@octane/spark'
import styled from 'styled-components'

export const Logo = styled.img`
    width: auto;
    height: 54px;
    flex-shrink: 0;
`

export const Banner = styled.div<{ $background: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: ${({ $background }) => $background};

    @media (max-width: 768px) {
        align-items: stretch;
        flex-direction: column;

        ${Logo} {
            align-self: flex-start;
        }
    }
`

export const TextSection = styled.div`
    flex: 1;
    margin-left: 24px;
`

export const Title = styled.p<{ $color: string }>`
    margin: 0 0 4px;
    color: ${({ $color }) => $color};
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
`

export const Description = styled.p<{ $color: string }>`
    margin: 0;
    color: ${({ $color }) => $color};
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 20px;
`

export const CtaButton = styled(Button)<{
    $background: string
    $backgroundHover: string
    $color: string
}>`
    height: 40px;
    background: ${({ $background }) => $background};
    border-color: ${({ $background }) => $background};
    color: ${({ $color }) => $color};
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;

    &:hover {
        background: ${({ $backgroundHover }) => $backgroundHover};
        border-color: ${({ $backgroundHover }) => $backgroundHover};
        color: ${({ $color }) => $color};
    }

    &:active {
        background: ${({ $background }) => $background};
        border-color: ${({ $background }) => $background};
        color: ${({ $color }) => $color};
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`
